import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { CheckCircle2 } from 'lucide-react-native';
import { memo, useEffect, useRef } from 'react';
import { Animated, Easing, View } from 'react-native';
import { aiColors } from '../../../../ai-suite/theme';

/** A step's mark: a filled check when done, a turning ring while on it. */
export const ReviewingStepMark = memo(
  ({ state }: { state: 'done' | 'active' | 'waiting' }) => {
    const { rpx } = useResponsiveContext();
    const turn = useRef(new Animated.Value(0)).current;
    useEffect(() => {
      if (state !== 'active') return;
      const spin = Animated.loop(
        Animated.timing(turn, {
          toValue: 1,
          duration: 900,
          easing: Easing.linear,
          useNativeDriver: true,
        }),
      );
      spin.start();
      return () => spin.stop();
    }, [state, turn]);
    const size = rpx(20);
    if (state === 'done')
      return (
        <CheckCircle2
          size={size}
          color={aiColors.card}
          fill={aiColors.accentForeground}
        />
      );
    const ring = {
      width: size,
      height: size,
      borderRadius: size / 2,
      borderWidth: 2,
    };
    if (state === 'waiting')
      return <View style={{ ...ring, borderColor: aiColors.border }} />;
    return (
      <Animated.View
        style={{
          ...ring,
          borderColor: aiColors.primary,
          borderTopColor: 'transparent',
          transform: [
            {
              rotate: turn.interpolate({
                inputRange: [0, 1],
                outputRange: ['0deg', '360deg'],
              }),
            },
          ],
        }}
      />
    );
  },
);
